import { useState } from "react";
import { Link } from "react-router-dom";
import { AlertOctagon, X, Send } from "lucide-react";
import { api } from "@/lib/api";

export const Footer = () => {
        const [showTipModal, setShowTipModal] = useState(false);
        const [tipContent, setTipContent] = useState("");
        const [tipUrl, setTipUrl] = useState("");
        const [tipStatus, setTipStatus] = useState("idle");

        const handleTipSubmit = async (e) => {
                e.preventDefault();
                setTipStatus("submitting");
                try {
                        await api.post("/tips", { content: tipContent, source_url: tipUrl });
                        setTipStatus("success");
                        setTipContent("");
                        setTipUrl("");
                        setTimeout(() => {
                                setShowTipModal(false);
                                setTipStatus("idle");
                        }, 3000);
                } catch (err) {
                        setTipStatus("error");
                }
        };

        return (
                <>
                        <footer className="border-t border-[var(--line-strong)] mt-32 bg-[var(--bg-deep)]">
                                <div className="mx-auto max-w-[1400px] px-6 lg:px-12 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
                                        <div className="md:col-span-5">
                                                <div className="overline text-[var(--ink-faint)] mb-4">
                                                        ◉ Arquivo independente
                                                </div>
                                                <p className="font-serif italic text-3xl leading-tight text-[var(--ink)]">
                                                        Verdades que se evitam.
                                                        <br />
                                                        <span className="text-[var(--ink-soft)] not-italic font-normal">
                                                                Estratégias que se desmontam.
                                                        </span>
                                                </p>
                                        </div>
                                        <div className="md:col-span-4">
                                                <div className="overline text-[var(--ink-faint)] mb-4 flex items-center justify-between">
                                                        <span>Método</span>
                                                        <Link to="/sobre" className="text-[var(--controversy)] hover:underline ml-2">Ler o manual →</Link>
                                                </div>
                                                <p className="text-sm leading-relaxed text-[var(--ink-soft)]">
                                                        Tópicos construídos contrastando factos verificáveis com
                                                        narrativas dominantes. Cruzamos fontes de informação independentes
                                                        sob curadoria editorial rigorosa. Cada origem
                                                        é citada no seu bloco próprio.
                                                </p>
                                        </div>
                                        <div className="md:col-span-3">
                                                <div className="overline text-[var(--ink-faint)] mb-4">
                                                        Aviso & Contacto
                                                </div>
                                                <p className="text-sm leading-relaxed text-[var(--ink-soft)] mb-4">
                                                        Análise crítica. Não constituem acusações jurídicas.
                                                        Pluralidade de leituras é convidada.
                                                </p>
                                                <button
                                                        onClick={() => setShowTipModal(true)}
                                                        className="px-3 py-1.5 flex items-center gap-2 bg-[var(--deception)] text-white font-mono text-[10px] tracking-widest uppercase hover:bg-red-700 transition-colors w-max"
                                                >
                                                        <AlertOctagon size={14} /> Denunciar / Fuga de Informação
                                                </button>
                                        </div>
                                </div>
                                <div className="border-t border-[var(--line)]">
                                        <div className="mx-auto max-w-[1400px] px-6 lg:px-12 py-4 flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                                                <span className="overline text-[var(--ink-faint)]">
                                                        © {new Date().getFullYear()} · Lisboa · sob sigilo parcial
                                                </span>
                                                <span className="overline text-[var(--ink-faint)]">
                                                        DOSSIÊ-ARQ-{new Date().getFullYear()}-PT
                                                </span>
                                        </div>
                                </div>
                        </footer>

                        {showTipModal && (
                                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
                                        <div className="bg-[var(--paper)] border border-[var(--line-strong)] p-6 md:p-8 w-full max-w-lg relative shadow-2xl">
                                                <button
                                                        onClick={() => setShowTipModal(false)}
                                                        className="absolute top-4 right-4 text-[var(--ink-soft)] hover:text-[var(--ink)]"
                                                >
                                                        <X size={20} />
                                                </button>
                                                <div className="flex items-center gap-3 mb-6">
                                                        <AlertOctagon size={24} className="text-[var(--deception)]" />
                                                        <h2 className="font-serif text-2xl text-[var(--ink)]">Canal de Denúncia</h2>
                                                </div>
                                                {tipStatus === "success" ? (
                                                        <div className="text-center py-8">
                                                                <div className="text-[var(--truth)] text-xl mb-4 font-serif italic">Denúncia recebida.</div>
                                                                <p className="text-[var(--ink-soft)] font-mono text-sm">A nossa equipa vai analisar a informação de forma segura e anónima.</p>
                                                        </div>
                                                ) : (
                                                        <form onSubmit={handleTipSubmit} className="space-y-4">
                                                                <p className="text-[var(--ink-soft)] font-mono text-[11px] mb-4">
                                                                        Partilha esquemas, contratos ocultos ou narrativas falsas. Garantimos anonimato total.
                                                                </p>
                                                                <div>
                                                                        <label className="block overline text-[var(--ink-faint)] mb-2">O que se passa?</label>
                                                                        <textarea
                                                                                required
                                                                                minLength={10}
                                                                                rows={4}
                                                                                className="w-full bg-transparent border border-[var(--line)] p-3 text-[var(--ink)] focus:border-[var(--ink)] outline-none"
                                                                                placeholder="Descreve o esquema ou a mentira da media..."
                                                                                value={tipContent}
                                                                                onChange={(e) => setTipContent(e.target.value)}
                                                                        />
                                                                </div>
                                                                <div>
                                                                        <label className="block overline text-[var(--ink-faint)] mb-2">Link para Prova (Opcional)</label>
                                                                        <input
                                                                                type="url"
                                                                                className="w-full bg-transparent border border-[var(--line)] p-3 text-[var(--ink)] focus:border-[var(--ink)] outline-none"
                                                                                placeholder="https://..."
                                                                                value={tipUrl}
                                                                                onChange={(e) => setTipUrl(e.target.value)}
                                                                        />
                                                                </div>
                                                                {tipStatus === "error" && <div className="text-[var(--deception)] font-mono text-[11px]">Erro ao enviar. Tenta novamente.</div>}
                                                                <button
                                                                        type="submit"
                                                                        disabled={tipStatus === "submitting"}
                                                                        className="w-full mt-4 flex items-center justify-center gap-2 bg-[var(--ink)] text-[var(--paper)] py-3 font-mono text-sm uppercase tracking-widest hover:bg-[var(--controversy)] disabled:opacity-50"
                                                                >
                                                                        {tipStatus === "submitting" ? "A Enviar..." : <><Send size={16} /> Enviar Informação Segura</>}
                                                                </button>
                                                        </form>
                                                )}
                                        </div>
                                </div>
                        )}
                </>
        );
};

export default Footer;
